import { t } from "src/shared/locales/i18n";
import { ButtonProduct } from "../style/ProductButton.style";

export type ProductCardButtonVariant = "normal" | "highlight" | "modal";
interface Props {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  variant?: ProductCardButtonVariant;
  href?: string;
  customLabel?: string;
}

const ProductButton = ({
  onClick,
  variant = "normal",
  href = "/",
  customLabel,
}: Props) => {
  return (
    <div className="akn-product-purchase-button-container">
      <ButtonProduct
        $variant={variant}
        className="akn-product-purchase-button"
        onClick={onClick}
      >
        <a href={href} target="_blank" rel="noreferrer">
          {customLabel ?? t("add_to_cart")}
        </a>
      </ButtonProduct>
    </div>
  );
};

export default ProductButton;
